// Видимый период сетки: чистые функции для RangeControls и экранов.
import { addDays, addMonthsISO, mondayOf, monthStartOf, sundayOf, today, type ISODate } from '@core/dates';

export type Range = { from: ISODate; to: ISODate };
export type Preset = { label: string; title: string; to: (from: ISODate) => ISODate };

const firstMondayFrom = (d: ISODate): ISODate => (mondayOf(d) === d ? d : addDays(mondayOf(d), 7));
const lastSundayTo = (d: ISODate): ISODate => (sundayOf(d) === d ? d : addDays(mondayOf(d), -1));

/** Конец диапазона: последняя полная неделя n-го месяца, считая от месяца начала. */
export function spanMonths(from: ISODate, months: number): ISODate {
  return lastSundayTo(addDays(addMonthsISO(monthStartOf(from), months), -1));
}
/** Конец диапазона: n полных недель от понедельника from. */
export const spanWeeksTo = (from: ISODate, weeks: number): ISODate => addDays(mondayOf(from), weeks * 7 - 1);

/** Роадмап по умолчанию: с первой полной недели прошлого месяца, шесть месяцев полными неделями. */
export function defaultRange(): Range {
  const from = firstMondayFrom(monthStartOf(addMonthsISO(today(), -1)));
  return { from, to: spanMonths(from, 6) };
}
export const MONTH_PRESETS: Preset[] = ([['Quarter', 3], ['Half year', 6], ['Year', 12]] as [string, number][])
  .map(([label, months]) => ({ label, title: `${months} months from the start`, to: (from) => spanMonths(from, months) }));

/** Release Plan: строго с текущей недели, 13 или 26 недель. */
export const RELEASE_PRESETS: Preset[] = [
  { label: '3 months', title: '13 weeks from the start', to: (from) => spanWeeksTo(from, 13) },
  { label: '6 months', title: '26 weeks from the start', to: (from) => spanWeeksTo(from, 26) },
];
export const defaultReleaseRange = (): Range => ({ from: mondayOf(today()), to: spanWeeksTo(mondayOf(today()), 13) });

/** Дата новой задачи из тулбара и строки: сегодня, если оно в периоде, иначе начало периода (не начало прошлого месяца). */
export const startWithin = (range: Range, now: ISODate = today()): ISODate => (now >= range.from && now <= range.to ? now : range.from);
